import Model from "@/lib/model/model";
import request from "@/lib/request/request";
// import { isEmpty } from "lodash-es";

/**
 * AI 答疑官组件化相关接口
 */
export default class IntelligentQA extends Model {
  // 语料新增
  static create(req: AIQaCreateOrUpdate) {
    return request
      .postComponentApi("intelligent_qa/qa/create", req)
      .then(res => {
        if (res.data.code === 0) {
          return res.data.data;
        }
      });
  }

  // 语料修改
  static update(req: AIQaCreateOrUpdate) {
    return request
      .postComponentApi("intelligent_qa/qa/update", req)
      .then(res => {
        if (res.data.code === 0) {
          return res.data.data;
        }
      });
  }

  // 列举语料
  static list(req: AIQaListReq) {
    return request.postComponentApi("intelligent_qa/qa/list", req).then(res => {
      if (res.data.code === 0) {
        return res.data.data;
      }
    });
  }
  // 语料变更问答对状态
  static toggleStatus(req: AIQaToggleStatusReq) {
    return request
      .postComponentApi("intelligent_qa/qa/toggleStatus", req)
      .then(res => {
        if (res.data.code === 0) {
          return res.data.data;
        }
      });
  }
  // 面试配置：配置答疑官
  static configBot(req: ConfigBotReq) {
    return request.post("aiExam/intelligentQA/configBot", req).then(res => {
      if (res.data.code === 0) {
        return res.data.data;
      }
    });
  }

  // 面试配置：获取智能答疑官配置
  static getBot(req: GetBotReq) {
    return request.post("aiExam/intelligentQA/getBot", req).then(res => {
      if (res.data.code === 0) {
        return res.data.data;
      }
    });
  }
  // 面试配置：配置答疑官下的问答对
  static configBotQA(req: ConfigBotQAReq) {
    return request.post("aiExam/intelligentQA/configBotQA", req).then(res => {
      if (res.data.code === 0) {
        return res.data.data;
      }
    });
  }
  // 面试配置：获取答疑官下的问答对列表
  static getBotQA(req: GetBotQAReq) {
    return request.post("aiExam/intelligentQA/getBotQA", req).then(res => {
      if (res.data.code === 0) {
        return res.data.data;
        // as AIQaPair;
      }
    });
  }
}

// 是否停用
export enum IS_DISABLED {
  ENABLE = 2, // 启用
  DISABLE = 1 // 停用
}

// 问题状态
export const IS_DISABLED_DICT = [
  { label: "已停用", value: IS_DISABLED.DISABLE, tagType: "danger" },
  { label: "已启用", value: IS_DISABLED.ENABLE, tagType: "primary" }
];

// 问题状态（搜索使用）
export const IS_DISABLED_SEARCH_DICT = [
  { label: "全部", value: 0 },
  { label: "停用", value: IS_DISABLED.DISABLE },
  { label: "启用", value: IS_DISABLED.ENABLE }
];

// 问题状态
export const TOGGLE_STATUS_DICT = [
  { label: "生成中", value: 1, tagType: "warning" },
  { label: "已启用", value: 2, tagType: "primary" },
  { label: "已停用", value: 3, tagType: "danger" }
];

// 问题状态（搜索使用）
export const TOGGLE_STATUS_SEARCH_DICT = [
  { label: "全部", value: 0 },
  ...TOGGLE_STATUS_DICT
];

export const getDictByValue = (dict: any, value: string | number) => {
  return dict.find((item: any) => item.value === value);
};

export const getIsDisabledLabel = (value: number) => {
  return getDictByValue(IS_DISABLED_DICT, value)?.label;
};

export const getIsDisabledTagType = (value: number) => {
  return getDictByValue(IS_DISABLED_DICT, value)?.tagType;
};

export const getStatusLabel = (value: number) => {
  return getDictByValue(TOGGLE_STATUS_DICT, value)?.label;
};

export const getStatusTagType = (value: number) => {
  return getDictByValue(TOGGLE_STATUS_DICT, value)?.tagType;
};

export interface AIQaToggleStatusReq {
  qaId: number; // 问答对id
  isDisabled: IS_DISABLED; // 是否停用
}

export interface AIQaListReq extends ListCommonReq {
  companyId?: number; // 公司id，在全局开启
  searchText?: string; // 搜索文本
  isDisabled?: IS_DISABLED; // 是否停用
}

export interface AIQaCreateOrUpdate {
  shortName: string; // 问题简称
  standardQuestion: string; // 标准问法
  standardAnswer: string; // 标准回答
  companyId?: number; // 公司id
  userId: number | string; // 用户id
  qaId?: number; // 问答对id
}

export interface AIQaPair {
  id: number; // 问答对id
  shortName: string; // 问题简称
  standardQuestion: string; // 标准问法
  standardAnswer: string; // 标准回答
  questionNo: number; // 问答对序号
  companyId: number; // 公司id
  isDisabled: IS_DISABLED; // 是否停用
  isRecommended: number; // 是否是推荐问题 1 推荐 2 不推荐
  status: number; // 问题状态, 0=全部, 1=生成中, 2=已启用, 3=已停用
  hitCount: number; // 命中次数
  updateUserName: string; // 更新用户名称
  createUserName: string; // 创建用户名称
  updateTime: string; // 更新时间
}

export interface GetBotQAReq extends ListCommonReq {
  examId: number | string; // 面试 ID
  companyId?: number | string; // 公司 ID
}

export interface GetBotReq {
  examId: number | string; // 面试 ID
  companyId?: number | string; // 公司 ID
}

export interface ListCommonReq {
  pageNum?: number;
  pageSize?: number;
}

export interface ListCommonRes {
  total: number;
  pageNum: number;
  pageSize: number;
  pageMax: number;
}

export interface ConfigBotReq {
  companyId?: number;
  idleVideo: string; // 默认聆听态视频
  examId?: number | string;
  isEnabled: number; // 答疑官开关：0-默认 1-开 2-关
  isBeforeExam: number; // 答疑官入口，答题前。0-默认 1-开 2-关
  isAfterExam: number; // 答疑官入口，答题后。0-默认 1-开 2-关
  greetingFirstTime: string; // 首次见面欢迎语
  greetingAgain: string; // 非首次见面欢迎语
  responseSeveralMatches: string; // 命中多个问题兜底话术
  responseNoMatch: string; // 未命中问题兜底话术
}

interface BotQAPairLinkItem {
  qaId: number; // 问答对id
  isRecommended: number; // 是否推荐
}

export interface ConfigBotQAReq {
  examId: number | string; // 面试 ID
  companyId?: number; // 公司 ID
  link: BotQAPairLinkItem[]; // 答疑官选择问题列表
}

export const mergeWithNotEmpty = (target: Object, source: Object) => {
  Object.keys(source).forEach(key => {
    if (!source[key]) {
      target[key] = source[key];
    }
  });
  return target;
};

export const emptyDefault = (value: string, defaultValue: string) => {
  console.log("🚀 ~ emptyDefault ~ defaultValue:", defaultValue);
  if (value === "" && defaultValue !== "") {
    return defaultValue;
  } else {
    return value;
  }
};
